/**
 * A crash event's stack trace. Both SDKs send it as `properties.stack_trace`;
 * ingestion now also copies it into the `stack_trace` column, but events
 * stored before that only have it in `properties`.
 */
export function crashStackTrace(event: {
  event_type?: string | null
  stack_trace?: string | null
  properties?: Record<string, unknown> | null
}): string | null {
  if (event.event_type !== 'crash') return null
  const trace = event.stack_trace ?? event.properties?.stack_trace
  return typeof trace === 'string' && trace.trim() ? trace : null
}
